import Trans from 'next-translate/Trans'
import React, { useState, useEffect } from 'react'
import useShowDoc from 'tennders-documents/hooks/useShowDoc'
import GModal from 'tennders-market/common/components/element/GModal'
import { ModalProps } from 'tennders-common/types/ModalProps'
import { apiPost } from 'tennders-stracture/libs/api'
import { toast } from 'react-toastify'
import useForm from 'tennders-common/form/hooks/useForm'
import { FieldsetContainer, GButton, TextInput } from 'tennders-common/form/components'
import useTranslation from 'next-translate/useTranslation'
import GImage from 'tennders-market/common/components/element/GImage'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'

type DocViewProps = ModalProps & {
  name ?: string,
  url ?: string,
}
const initialForm = {
  name: '',
  email: ''
}
const DocView = ({ ...rest }: DocViewProps) => {
  const { document, setDocument } = useShowDoc()
  const { form, errors, onChange, resetForm } = useForm({ initialForm })
  const { t } = useTranslation()
  const [showPocForm, setShowPocForm] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const sendAgainUrl = document?.sendAgain

  const sendAgain = async () => {
    setSubmitting(true)
    const data = await apiPost(sendAgainUrl, { ...form })

    if (data.status) {
      toast.success(t('document:docSentAgain'))
      resetForm()
      setDocument(false)
    }
    setSubmitting(false)
  }

  useEffect(() => {
    if (!document) {
      setShowPocForm(false)
    }
  }, [document])
  return (
    <GModal isOpen={!!document} close={() => setDocument(false)} goBack={showPocForm && (() => setShowPocForm(false))} {...rest}>
      <div className="tennders-modal-body w-100">
        {showPocForm ? (
          <div className="d-flex row mb-16 mt-8">
            <div className="d-flex align-center w-100">
              <h3 className="mb-4 bold">{t('document:pocInformation')}</h3>
            </div>
            <div className="w-50">
              <div className="pr-8">
                <FieldsetContainer
                  name="name"
                  form={form}
                  label={t('addBranch:name')}
                  errors={errors}
                  onChange={onChange}
                  required
                  renderInput={(rest) => (
                    <TextInput
                      className="form-input small"
                      {...rest}
                    />
                  )}
                />
              </div>
            </div>
            <div className="w-50">
              <div className="pl-8">
                <FieldsetContainer
                  name="email"
                  form={form}
                  label={t('addBranch:email')}
                  errors={errors}
                  onChange={onChange}
                  required
                  renderInput={(rest) => (
                    <TextInput
                      className="form-input small"
                      maxLength={INPUT_CHARACTER_LIMITS.EMAIL}
                      {...rest}
                    />
                  )}
                />
              </div>
            </div>
            <GButton submitting={submitting} disabled={!(form?.name && form?.email)} className="btn standard-btn mt-4 ml-auto " onClick={sendAgain}>
              <Trans i18nKey="document:sendAgain" />
            </GButton>
          </div>
        ) : (
          <>
            <div className="d-flex align-center justify-space mb-8">
              <h3 className="mb-0 bold">{document?.title}</h3>
              <div className="d-flex row">
                <a target="_blank" href={document?.fullUri} className="ml-16 mr-16 text-underline" rel="noreferrer">
                  {' '}
                  <Trans i18nKey="document:download" />
                </a>
                {document?.sendAgain ? (
                  <a onClick={() => setShowPocForm(true)} className="mr-16 text-underline cursor-pointer" rel="noreferrer">
                    <GImage src="icon-send-again.svg" />
                  </a>
                ) : null}
              </div>
            </div>
            <div className="tennders-wrapper">
              <iframe
                title={<Trans i18nKey="document:download" /> as any}
                src={document?.fullUri}
                className="tennders-modal-pdf-file w-100"
                style={{ minHeight: '64vh' }}
                allowFullScreen
              />
            </div>
          </>
        )}
      </div>
    </GModal>
  )
}
export default DocView
